module.exports = __webpack_public_path__ + "img/bulb-white.aac98243.svg";